/**
 * ScopedGatePass — Embeds the GatePass workflow inside a School (tenant) context.
 * Same components as `/admin/gate-pass`, but POSTs always carry context_type=school
 * and context_id=tenantId so each tenant only sees their own passes.
 *
 * Reuses everything from /pages/GatePassPage.jsx — no duplicated logic.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldCheck, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ScopedGatePass({ tenantId }) {
  const navigate = useNavigate();
  return (
    <div className="space-y-3">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-sm">
            <ShieldCheck className="h-4 w-4" /> Gate Pass · this school
          </CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-slate-600 space-y-2">
          <p>Gate-pass requests, approvals, exit/return scans for this school.</p>
          <Button
            onClick={() => navigate(`/admin/gate-pass?context_type=school&context_id=${tenantId}`)}
            data-testid="open-gate-pass-page"
          >
            <ExternalLink className="h-4 w-4 mr-1" /> Open full Gate-Pass page
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
